import {
  createRouter,
  createWebHashHistory,
  // createWebHistory
} from 'vue-router'

import Index from '../pages/index/index.vue'
import Rule from '../pages/rule/index.vue'
import Detail from '../pages/detail/index.vue'
import Search from '../pages/search/index.vue'
import ViolationPublicity from '../pages/violationPublicity/index.vue'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '规则平台-唯品会名牌时尚折扣网'
    }
  },
  {
    path: '/rule',
    name: 'Rule',
    component: Rule,
    meta: {
      title: '规则平台-唯品会名牌时尚折扣网'
    }
  },
  {
    path: '/notice',
    name: 'Notice',
    component: Rule,
    meta: {
      title: '规则平台-唯品会名牌时尚折扣网'
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      title: '规则平台-唯品会名牌时尚折扣网'
    }
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail,
    meta: {
      title: '规则平台-唯品会名牌时尚折扣网'
    }
  },
  {
    path: '/noticeDetail',
    name: 'NoticeDetail',
    component: Detail,
    meta: {
      title: '规则平台-唯品会名牌时尚折扣网'
    }
  },
  {
    path: '/violationPublicity',
    name: 'ViolationPublicity',
    component: ViolationPublicity,
    meta: {
      title: '规则平台-唯品会名牌时尚折扣网'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
